module.exports = __webpack_public_path__ + "static/img/open.1044779c.jpg";